import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=ce8c73bc&scoped=true&"
import script from "./TemplateView.vue?vue&type=script&lang=js&"
export * from "./TemplateView.vue?vue&type=script&lang=js&"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=ce8c73bc&lang=scss&"
import style1 from "./TemplateView.vue?vue&type=style&index=1&id=ce8c73bc&lang=scss&scoped=true&"
import style2 from "./TemplateView.vue?vue&type=style&index=2&id=ce8c73bc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8c73bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce8c73bc')) {
      api.createRecord('ce8c73bc', component.options)
    } else {
      api.reload('ce8c73bc', component.options)
    }
    module.hot.accept("./TemplateView.vue?vue&type=template&id=ce8c73bc&scoped=true&", function () {
      api.rerender('ce8c73bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/requests/view/TemplateView.vue"
export default component.exports